import styled from 'styled-components';

import {AdminListingPageContainer} from '../../../../../elements-new';

export const ViewClassContainer = styled(AdminListingPageContainer)``;
